'use strict';

var _resolve = require('./private/renderer/resolve');

var _ContextProps = require('./private/types/ContextProps');

var _Identifiers = require('./private/types/Identifiers');

var _getByIdentifier = require('./private/tags/values/get-by-identifier');

var _renderToStaticMarkup = require('./private/renderer/render-to-static-markup');

module.exports = {
  renderToStaticMarkup: _renderToStaticMarkup.renderToStaticMarkup,
  renderJsonLd: _renderToStaticMarkup.renderJsonLd,
  resolve: _resolve.resolve,
  getValueByIdentifier: function getValueByIdentifier() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        tags = _ref.tags;

    var identifier = arguments[1];
    return (0, _getByIdentifier.getValueByIdentifier)(tags, identifier);
  },
  CONTEXT_PROPS: _ContextProps.CONTEXT_PROPS,
  EXTERNAL_IDENTIFIERS: _Identifiers.EXTERNAL_IDENTIFIERS
};